import React, { JSX } from "react";
import { Box, Typography } from "@mui/material";
import styles from "./Assessment.module.css";
import TextBox from "../../../components/TextBox/TextBox";

interface Props {
  onChange: (val: string) => void;
  value: string;
}

const MedicalAssessmentRemarks = ({ onChange, value }: Props): JSX.Element => (
  <Box className={styles.assessmentRow}>
    <Box className={styles.assessmentLabel}>
      <Typography component="span" fontWeight="600">
        Remarks
      </Typography>
    </Box>
    <Box className={styles.assessmentField}>
      <TextBox
        onFocus={(e) => e.target.select()}
        data-testmation="remarks"
        margin="dense"
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        value={value}
        placeholder="Type remarks"
        showTextCounter
        counterLength={260}
        slotProps={{
          htmlInput: { maxLength: 260 },
          formHelperText: { style: { position: "absolute", right: 0, bottom: -5, margin: 5 } }
        }}
        onSave={(v) => onChange(v)}
      />
    </Box>
  </Box>
);

export default MedicalAssessmentRemarks;
